import { ReactNode, Suspense } from 'react';
import { useFeatureFlag } from '../lib/useFeatureFlag';
import { Features, Flag } from '../model/Feature';

export interface FeatureProps<F extends Flag> {
  feature: F;
  children: ReactNode | ((value: Features[F] | undefined) => ReactNode);
}

export function Feature<F extends Flag>({ feature, children }: FeatureProps<F>) {
  const value = useFeatureFlag(feature);

  if (typeof children === 'function') {
    return <Suspense>{children(value)}</Suspense>;
  }

  return value ? <Suspense>{children}</Suspense> : null;
}
